<template>
    <div class="wrapper">
        <span class="title">{{ $t('CAMPAIGN_FLOW.TITLE') }}</span>
        <input
            type="text"
            :placeholder="$t('CAMPAIGN_FLOW.SIDEBAR_SEARCH_FIELD.PLACEHOLDER')"
            v-model="searchQuery"
        >
        <ul class="list">
            <li
                v-for="currentCampaign in filteredCampaigns" :key="currentCampaign.id"
                @click="handleSelectedCampaign(currentCampaign)"
                class="item"
                :class="{'selected': selectCampaign && selectCampaign.id === currentCampaign.id}"
                >
                <div class="item-text">
                    <!-- <fluent-icon icon="flash " size="16"/> -->
                    {{ currentCampaign.title }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CampaignsFlowSidebar',
    components: {  },
    data() {
        return {
            selectCampaign: null,
            searchQuery: ''
        };
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
            currentUser: 'getCurrentUser',
            listCampaigns: 'campaignsFlow/getCampaigns'
        }),
        filteredCampaigns() {
            return this.listCampaigns.filter(campaign =>
                campaign.title.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    methods: {
        showAlert(message) {
            bus.$emit('newToastMessage', message);
        },

        handleSelectedCampaign(campaign){
          this.selectCampaign = campaign;
            this.$store.dispatch('campaignsFlow/setCampaign', { campaign });
        }
    }
};
</script>

<style scoped>
.wrapper {
    padding: 8px;
}

.title {
    color: var(--s-700);
    display: flex;
    font-weight: var(--font-weight-bold);
    line-height: var(--space-normal);
    margin: var(--space-small) 0;
    padding: 0 var(--space-small);
    font-size: var(--font-size-small);
}

input {
    margin: 0 0 0 8px;
    height: 3rem;
    width: calc(100% - 16px);
    padding: 8px;
    border: 1px solid var(--s-400);
    border-radius: 4px;
}

.item-text {
    display: flex;
    align-items: center;
    color: var(--s-600);
    font-weight: var(--font-weight-medium);
    width: calc(100% - 16px);
    /* altura automática: nomes longos quebram DENTRO do item (o fundo do
       selecionado cobre todas as linhas, sem vazar). US-4328 */
    min-height: var(--space-medium);
    padding: var(--space-smaller) var(--space-small);
    margin: var(--space-smaller) 0;
    text-align: left;
    line-height: 1.3;
    font-size: 14px;
    gap: 0.3rem;
    word-break: break-word;
    overflow-wrap: anywhere;
}
.item-text:hover {
    color: var(--g-20) ;
}

.item {
    cursor: pointer;
    margin: 5px 12px 0 0;
}

.item.selected {
    /* era --w-25 (#F5FAFF) fixo → item selecionado branco no dark. Tinta cyan
       do tema (padrão), funciona nos dois. US-4328 */
    background-color: var(--color-woot-tint);
    border-radius: 8px;
}


.item.selected .item-text {
    color: var(--g-20);
    background-color: black;
    background: fixed;
}
</style>
